<script>
    import dressing from "@intellectability/platform-common";
    import {FlexList, Icon} from "@intellectability/platform-common/sv";
    import {Card,CardBody,Col,Container,Row} from "@sveltestrap/sveltestrap";
    import {fade} from "svelte/transition";
    
    /**
     * @typedef {Object} props
     * @property {string} [entity] - The entity type, e.g., "critical_incident"
     * @property {string} [id] - The ID of the entity to display logs for
     * @property {string} [parent_entity] - The parent entity type, e.g., "consumer"
     * @property {string} [parent_id] - The ID of the parent entity
     */
    /** @type {props} */
    let {
        entity,
        id,
        parent_entity,
        parent_id
    } = $props();

    let loading = $state(true);
  
    /**
     * @typedef {Object} Log - Represents a message in the system
     * @property {string} date_time - The date and time when the log was created.
     * @property {string} change_made - A description of the change that was made.
     * @property {number} user_id - The ID of the user who made the change.
     * @property {string} user_name - The name of the user who made the change.
     */
    // flexlist data
    /** @type {Log[]} */
    let logs = $state.raw([]);

    // filter options
    let filterForDate = $state("");
    let filterForChangeMade = $state("");
    let filterForChanger = $state("");
    
    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: -1,
        recordsTotal: -1,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    /** @type {{field: string, order: 'asc'|'desc'}} */
    let sort = $state({
        field: "date_time",
        order: "desc"
    });

    $effect( () => {
        fetch_filter_list();
    });

    function fetch_filter_list() {
        const filter_query = {
            date_time: filterForDate || null,
            change_made: filterForChangeMade || null,
            user_name: filterForChanger || null,
        };

        const sort_query = {
            sort: sort.field || null,
            order: sort.order || null
        };

        const page_query = {
            page: pagination.page || null,
            limit: pagination.limit || null
        };

        let url = "";
        if(entity && entity.length && id && id.length) {
            url = `/logs/${entity}/${id}`;
        } else if(parent_entity && parent_entity.length && parent_id && parent_id.length) {
            // TODO: Find a use case for parent_entity and parent_id and adjust the URL accordingly.
            url = `/logs/${parent_entity}/${parent_id}`;
        } else {
            // TODO: throw create_security_error("Entity or ID is not provided for fetching logs.");
        }
        if(url && url.length > 0)
            dressing.get(url, {params: Object.assign(filter_query, {...sort_query, ...page_query})
                }).then(({data: response}) => {
                    const {success, data} = response;
                    if (success === true) {
                        if (data.logs) {
                            logs = data.logs;
                            pagination.recordsFiltered = data.recordsFiltered;
                            pagination.recordsTotal = data.recordsTotal;
                        }
                    }
                    loading = false;
                });
    }

</script>

<main class="mb-4 pt-4 pt-lg-0">

    <div transition:fade={{ duration: 350, delay: 150 }}>
        
        <!-- Page Title -->
        <h1>
            <Icon icon="clock-rotate-left"/>
            Change Log
        </h1>
        <!-- TABLE -->
        <FlexList
                {loading}
                pagerConfig={pagination}
                onpagechange={(/** @type {number} */ page) => (pagination.page = page)}
                onsort={(/** @type {string} */ field, /** @type {'asc'|'desc'} */ order) => {sort = { field, order };}}
                onpagelengthchange={(/** @type {number} */ newLimit) => (pagination.limit = newLimit)}
                columns={[
                    {
                        name: "Date Time",
                        field: "date_time",
                        width: "",
                        sortedBy: sort.field === "date_time" ? sort.order : undefined,
                        sortable: true,
                        collapse: false, // do not hide when in mobile view
                        filterType: "text",
                        filterPlaceholder: "Search",
                        onfilter: function (/** @type {string} */ value) {
                            filterForDate = value;
                        }
                    },
                    {
                        name: "Change Made",
                        field: "change_made",
                        width: "",
                        sortedBy: sort.field === "change_made" ? sort.order : undefined,
                        sortable: true,
                        collapse: false, // do not hide when in mobile view
                        filterType: "text",
                        cell: preFormattedText,
                        filterPlaceholder: "Search",
                        onfilter: function (/** @type {string} */ value) {
                            filterForChangeMade = value;
                        },
                    },
                    {
                        name: "User",
                        field: "user_name",
                        width: "",
                        sortedBy: sort.field === "user_name" ? sort.order : undefined,
                        sortable: true,
                        filterType: "text",
                        filterPlaceholder: "Search",
                        onfilter: function (/** @type {string} */ value) {
                            filterForChanger = value;
                        },
                    },
                ]}
                data={logs}>
        </FlexList>
    </div>
</main>

{#snippet preFormattedText(row, field, column)}
<pre style="font-family: Arimo, sans-serif">{row[field]}</pre>
{/snippet}